import type { Transition, Variants } from 'framer-motion'

export const homeEase = [0.22, 1, 0.36, 1] as const

export const homeTransition: Transition = {
  duration: 0.55,
  ease: homeEase,
}

export const homeStagger: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.1, delayChildren: 0.06 },
  },
}

export const homeFadeUp: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0 },
}

export const homeFadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
}

export const homeScaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.96 },
  visible: { opacity: 1, scale: 1 },
}
